var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":"animated fadeIn faster","leave-active-class":"animated fadeOut faster","mode":"out-in"}},[_c(_vm.property.component,_vm._b({tag:"component"},'component',{ property: _vm.property },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }